export { LiantisLogo } from './liantis-logo';
